












































































































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import UserValidator from "@/resources/mixins/userValidator";
import { MEETING_TYPE } from "@/resources/constants/meeting";
import FloatMenuAnimation from "@/resources/mixins/animations/floatMenuAnimation";
import feather from "feather-icons";
import { CHAT_TYPE } from "@/resources/constants/chat";
import { SpaceInterface } from "@/resources/interfaces/spaceInterfaces";
import LayoutTypesComponent from "./layoutTypes.component.vue";
import Plans from "@/resources/mixins/plans/plans";
import { PLAN } from "@/resources/constants/plan";
@Component({
  name: "call-header-component",
  components: {
    LayoutTypesComponent,
  },
})
export default class CallHeaderComponent extends mixins(
  UserValidator,
  FloatMenuAnimation,
  Plans
) {
  PLAN = PLAN;
  MEETING_TYPE = MEETING_TYPE;
  usersInCallNumber = 1;
  mounted() {
    feather.replace();
    const meetingType = this.$store.getters["MeetingStore/getMeetingType"];
    /*  if (meetingType === this.MEETING_TYPE.SPEED_NETWORKING)
      this.changeDisplayMode(); */
    if (
      meetingType !== null &&
      meetingType !== MEETING_TYPE.ONE_TO_ONE &&
      meetingType !== MEETING_TYPE.SPEED_NETWORKING &&
      meetingType !== MEETING_TYPE.MEETING
    ) {
      this.getNumberOfUsers();
    }
  }
  isWebinar(): boolean {
    const space = this.$store.getters["SpaceStore/getSpace"];
    return (
      (space.superSpace.isMultiWebinarActivated
        ? this.isMultiWebinarUser()
        : this.isWebinarUser()) || this.meetingType !== MEETING_TYPE.WEBINAR
    );
  }
  isWebinarAdmin(): boolean {
    const space = this.$store.getters["SpaceStore/getSpace"];
    return (
      (space.superSpace.isMultiWebinarActivated
        ? this.isSuperSpaceAdmin()
        : this.isAdmin()) || this.meetingType !== MEETING_TYPE.WEBINAR
    );
  }
  changeDisplayMode() {
    if (!this.activeOptionPlan(PLAN.CHANGE_CAMERA_GRID)) return;
    setTimeout(() => this.openLayoutTypes(), 20);
  }
  get meetingType() {
    return this.$store.getters["MeetingStore/getMeetingType"];
  }
  get usersInCall() {
    return this.$store.getters["MeetingStore/getUsersInCall"];
  }
  get callIsRecord() {
    return this.$store.getters["MeetingStore/getCallIsRecord"];
  }
  get isChatWebinarActive() {
    const meetingType = this.$store.getters["MeetingStore/getMeetingType"];
    return (
      this.$store.getters["SpaceStore/getSpace"].isWebinarChatActive ||
      meetingType !== MEETING_TYPE.WEBINAR
    );
  }
  get unSeeMessage() {
    return this.$store.getters["ChatStore/getUnSeenMessage"];
  }
  get showBadgeNewMessage() {
    const roomId = this.$store.getters["MeetingStore/getRoomId"];
    return this.unSeeMessage.filter(
      (a) =>
        a.type === CHAT_TYPE.ROOM &&
        JSON.parse(a.payload.Metadata).roomId === roomId
    ).length;
  }
  get space(): SpaceInterface {
    return this.$store.getters["SpaceStore/getSpace"];
  }
  get layoutTypeImage(): string {
    const img = this.$store.getters["MeetingStore/getLayoutType"];
    return require(`@/assets/images/icons/${img}.svg`);
  }
  get focusMode(): boolean {
    return this.$store.getters["MeetingStore/getFocusMode"];
  }
  get countPlayerInCall(): boolean {
    return this.$store.getters["MeetingStore/getCountPlayerInCall"];
  }
  changeFocusMode() {
    if (!this.activeOptionPlan(PLAN.FOCUS_MODE)) return;
    const focus = !this.focusMode;
    localStorage.setItem("focusMode", focus.toString());
    this.$store.dispatch("MeetingStore/setFocusModeAction", focus);
    /*  setTimeout(() => {
      this.$store.dispatch("GraphicClientStore/resizeGraphicClientAction");
    }, 20); */
  }
  openUsersInCallMenu() {
    this.getUsersInCall();
    setTimeout(() => this.openUsersInCall(), 20);
  }
  getNumberOfUsers() {
    const roomId = this.$store.getters["MeetingStore/getRoomId"];
    const space = this.$store.getters["SpaceStore/getSpace"];
    const meetingType = this.$store.getters["MeetingStore/getMeetingType"];
    if (
      (meetingType === MEETING_TYPE.WEBINAR &&
        !space.superSpace.isMultiWebinarActivated) ||
      meetingType !== MEETING_TYPE.WEBINAR
    ) {
      this.$store.dispatch("SpaceUserStore/getNumberOfUsersInWebinarAction", {
        roomId,
        callback: (data) => {
          this.usersInCallNumber = data.usersConnectedToRoomCounter;
          this.$store?.dispatch(
            "MeetingStore/setCountPlayerInCallAction",
            data.usersConnectedToRoomCounter
          );
        },
      });
    } else if (space.superSpace.isMultiWebinarActivated) {
      this.$store.dispatch(
        "SuperSpaceStore/getNumberOfUsersInMultiWebinarAction",
        {
          superSpaceId: space.superSpace.id,
          callback: (data) => {
            this.usersInCallNumber = data.usersConnectedToRoomCounter;
            this.$store?.dispatch(
            "MeetingStore/setCountPlayerInCallAction",
            data.usersConnectedToRoomCounter
          );
          },
        }
      );
    }
  }
  getUsersInCall() {
    const roomId = this.$store.getters["MeetingStore/getRoomId"];
    const space = this.$store.getters["SpaceStore/getSpace"];
    const meetingType = this.$store.getters["MeetingStore/getMeetingType"];
    if (
      (meetingType === MEETING_TYPE.WEBINAR &&
        !space.superSpace.isMultiWebinarActivated) ||
      meetingType !== MEETING_TYPE.WEBINAR
    ) {
      this.$store.dispatch("MeetingStore/setUsersInCallAction", []);
      this.$store.dispatch("SpaceUserStore/getSpaceUsersInWebinarAction", {
        roomId,
        page: 1,
        search: "",
        callback: (response) => {
          this.usersInCallNumber = response.headers["pagination-total-items"];
          this.$store?.dispatch(
            "MeetingStore/setCountPlayerInCallAction",
            response.headers["pagination-total-items"]
          );
          this.$store.dispatch(
            "MeetingStore/setUsersInCallAction",
            response.data
          );
        },
      });
    } else if (space.superSpace.isMultiWebinarActivated) {
      this.$store.dispatch("MeetingStore/setUsersInCallAction", []);
      this.$store.dispatch(
        "SuperSpaceStore/getSuperSpaceUsersInMultiWebinarAction",
        {
          superSpaceId: space.superSpace.id,
          page: 1,
          search: "",
          callback: (response) => {
            this.usersInCallNumber = response.headers["pagination-total-items"];
            this.$store?.dispatch(
              "MeetingStore/setCountPlayerInCallAction",
              response.headers["pagination-total-items"]
            );
            this.$store.dispatch(
              "MeetingStore/setUsersInCallAction",
              response.data
            );
          },
        }
      );
    }
  }
  openRecord() {
    if (!this.activeOptionPlan(PLAN.MEETING_RECORDING)) return;
    this.openRecordOptions();
  }
}
